module.exports = __webpack_public_path__ + "static/kiwi.f06921c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectPartners/images/kiwi.png
// module id = 436
// module chunks = 35783957827783